export default "\n\n<ngx-spinner size=\"medium\" color=\"#B50092\" size = \"medium\" type = \"ball-pulse\"></ngx-spinner>\n<router-outlet></router-outlet>"